import { applyFilters, convertStringToArray, generateErrors } from 'utilities/util';
import { IStore } from 'reducers/index';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/booking';
import { TYPES as FILTER_TYPES } from 'action-types/filters';
import { callApiV2Get, callApiV3Post } from 'utilities/apiCaller';
import API from 'constants/api';
import { TransportMode } from 'constants/modes';

export const fetchBookingsData = (pageNumber?: number, pageSize?: number, genericFilter?: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.FETCH_BOOKING_DATA.PENDING });
        try {
            const res = await callApiV3Post(API.Booking.GetBookings, applyFilters(convertStringToArray(getState, 'ReferenceNumbers'), {
                isAirInFilters: false,
                isAirInBody: false
            }, {
                Page: pageNumber,
                PageNumber: pageNumber,
                PageSize: pageSize,
                GenericFilter: genericFilter
            }), { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: res.data.totalCount });
            dispatch({ type: TYPES.FETCH_BOOKING_DATA.FULFILLED, bookings: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_BOOKING_DATA.REJECTED, errors });
        }
    }
};

export const resetBookingData = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_RESET_DATA.PENDING });
        dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: 0 });
        dispatch({ type: TYPES.FETCH_RESET_DATA.FULFILLED, bookings: [] })
    }
};
export const fetchBookingDetails = (bookingId: number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_BOOKING_DETAILS.PENDING });
        try {
            const res = await callApiV2Get(`${API.Booking.BookingDetails}/${bookingId}`, {}, {});
            dispatch({ type: TYPES.FETCH_BOOKING_DETAILS.FULFILLED, bookingDetails: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_BOOKING_DETAILS.REJECTED, errors });
        }
    }
};
